import React from "react";
import { JSX } from "react/jsx-runtime";

const ShareIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="37" height="35" viewBox="0 0 37 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <ellipse cx="18.4999" cy="17.1853" rx="17.619" ry="16.3669" fill="#5376F0" fill-opacity="0.1"/>
        <path d="M18.5 1.31836C27.9899 1.31841 35.6191 8.45658 35.6191 17.1855C35.619 25.9144 27.9898 33.0517 18.5 33.0518C9.01015 33.0518 1.38101 25.9144 1.38086 17.1855C1.38086 8.45655 9.01006 1.31836 18.5 1.31836Z" stroke="#5376F0" stroke-opacity="0.5"/>
        <path d="M28.0002 16.1259L18.4002 10.2188L18.4002 13.5629C10 15.235 10 23.038 10 23.038C10 23.038 13.6 18.5792 18.4002 19.1365L18.4002 22.5921L28.0002 16.1259Z" stroke="#0C099C" stroke-width="2" stroke-linejoin="round"/>
    </svg>
  );
};

export default ShareIcon; 